import type { ReactNode } from 'react';
import { IconCheck } from '@tabler/icons-react';
import { useFela } from 'react-fela';

import * as felaRules from './Submenu.rules';

export interface SubmenuOption<Key extends string> {
    key: Key;
    label: ReactNode;
}

export interface SubmenuProps<Key extends string> {
    options: SubmenuOption<Key>[];
    activeKey?: string;
    onSelect: (key: Key) => void;
}

export const Submenu = <Key extends string>({ options, activeKey, onSelect }: SubmenuProps<Key>) => {
    const { css } = useFela();

    return (
        <div role='menu' className={css(felaRules.container)}>
            {options.map(option => {
                const active = option.key === activeKey;

                return (
                    <button
                        key={option.key}
                        type='button'
                        role='menuitem'
                        aria-current={active}
                        className={css(felaRules.option, active && felaRules.optionActive)}
                        onClick={() => onSelect(option.key)}
                    >
                        <span className={css(felaRules.check)}>{active && <IconCheck size={16} />}</span>
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};
